// export const url = process.env.REACT_APP_API_URL || "http://localhost:3000"
// export const chatbotUrl = process.env.REACT_APP_CHATBOT_URL || "http://localhost:8000/v1"
// export const webhookUrl = process.env.REACT_APP_WEBHOOK_URL  || "http://localhost:3002"
export const url = process.env.REACT_APP_API_URL || "https://api.cloudflick.in"
export const chatbotUrl = process.env.REACT_APP_CHATBOT_URL || "http://localhost:8000/v1"
export const webhookUrl = process.env.REACT_APP_WEBHOOK_URL  || "https://webhook.cloudflick.in"